import { useEffect, useState } from 'react';
import FilterAltTwoToneIcon from '@mui/icons-material/FilterAltTwoTone';
import './MyNominationFilter.css';

export default function MyNominationFilter({nominationList,filteredData,setFilteredData,skillType}) {                    
  const [filterShow, setFilterShow] = useState(false);   
  const [searchTerm, setSearchTerm] = useState('');
  const [selectAll, setSelectAll] = useState(true); 
  const [selectedOptions, setSelectedOptions] = useState([]);         
  const [optionsData, setOptionsData] = useState([]);          
  
  let courseName = nominationList.map(item => item.courseName)  
  let startDate = nominationList.map(item => item.startDate)  
  let mode = nominationList.map(item => item.sessionType)           
  let status = nominationList.map(item => item.status)
  const statusDetails = {
    0: `Failed Nomination`,
    1: `Waiting for Batch Allocation`,
    2: `Scheduled`,
    3: `Rejected`,
    4: `Waitlisted`,
    5: `Discarded`,
  }
  courseName = courseName.filter((value, index, array) => {
    return array.indexOf(value) === index;
  })    
  startDate = startDate.filter((value, index, array) => {
    return array.indexOf(value) === index;
  })  
  mode = mode.filter((value, index, array) => {
    return array.indexOf(value) === index;
  })  
  status = status.filter((value, index, array) => array.indexOf(value) === index
  ).map(value => statusDetails[value])

  useEffect(() => {        
    if(skillType === 'course_name') {
      setOptionsData(courseName)
      setSelectedOptions(courseName)
    } else if(skillType === 'start_date') {
      setOptionsData(startDate)
      setSelectedOptions(startDate)
    } else if(skillType === 'mode'){ 
      setOptionsData(mode)
      setSelectedOptions(mode)
    } else {
      setOptionsData(status)
      setSelectedOptions(status)
    }   
  },[nominationList])  

  useEffect(() => {
    let courseName = filteredData.map(item => item.courseName)  
    let startDate = filteredData.map(item => item.startDate)    
    let mode = filteredData.map(item => item.sessionType)         
    let status = filteredData.map(item => item.status)
    courseName = courseName.filter((value, index, array) => {
      return array.indexOf(value) === index;
    })    
    startDate = startDate.filter((value, index, array) => {
      return array.indexOf(value) === index;
    })    
    mode = mode.filter((value, index, array) => {
      return array.indexOf(value) === index;
    })
    status = status.filter((value, index, array) => array.indexOf(value) === index
  ).map(value => statusDetails[value])

    if(skillType === 'course_name') {
      setSelectedOptions(courseName)
    } else if(skillType === 'start_date') {      
      setSelectedOptions(startDate)
    } else if(skillType === 'mode'){      
      setSelectedOptions(mode)
    } else {      
      setSelectedOptions(status)
    }
  },[filteredData])

  useEffect(() => {     
    if(selectedOptions.length === optionsData.length) {      
      setSelectAll(true);
    }        
    else {
      setSelectAll(false);      
    }        
  },[selectedOptions])

  const handleFilterShow = (e) =>  {
    setFilterShow(!filterShow)             
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    let filteredOptions = [];
    filteredOptions = ((skillType === 'course_name' && courseName)  || (skillType === 'mode' && mode)
    || (skillType === 'start_date' && startDate) || (skillType === 'status' && status))
    .filter((option) => option.toLowerCase().includes(e.target.value.toLowerCase()));    
    
    setOptionsData(filteredOptions);
  };  
  const handleCheckboxChange = (e,option) => {                            
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  
    if(skillType === 'course_name') {  
      !e.target.checked && setFilteredData(filteredData.filter(item => item.courseName !== option))      
      if(e.target.checked) {
        let data = nominationList.filter(item => item.courseName === option);                                          
          setFilteredData(filteredData => [...filteredData , ...data]);                                  
      }
    } else if(skillType === 'start_date') {      
      !e.target.checked && setFilteredData(filteredData.filter(item => item.startDate !== option))      
      if(e.target.checked) {
        let data = nominationList.filter(item => item.startDate === option);                                          
          setFilteredData(filteredData => [...filteredData , ...data]);                                  
      }
    } else if(skillType === 'mode'){
      !e.target.checked && setFilteredData(filteredData.filter(item => item.sessionType !== option))
      if(e.target.checked) {          
        let data = nominationList.filter(item => item.sessionType === option);                        
        setFilteredData(filteredData => [...filteredData , ...data]);
      }} else {
        const statusNumbers = Object.fromEntries(
          Object.entries(statusDetails).map(([key, value]) => [value, Number(key)])
        );
        !e.target.checked && setFilteredData(filteredData.filter(item => item.status != statusNumbers[option]))
        if(e.target.checked) {          
          let data = nominationList.filter(item => item.status == statusNumbers[option]);
          setFilteredData(filteredData => [...filteredData , ...data]);
        }
    }    
  };            
  function handleCheckboxSelectAllChange(e) {    
    setSelectAll(e.target.checked);       
    if(skillType === 'course_name') {      
      if(e.target.checked) {        
        setSelectedOptions(courseName);
        setFilteredData(nominationList);
      } else {        
        setSelectedOptions([]);
        setFilteredData([]);
      }
    } else if(skillType === 'start_date') {      
      if(e.target.checked) {        
        setSelectedOptions(startDate);
        setFilteredData(nominationList);
      } else {        
        setSelectedOptions([]);
        setFilteredData([]);
      }
    } else if(skillType === 'mode') {            
      if(e.target.checked) {
        setSelectedOptions(mode);
        setFilteredData(nominationList);        
      } else {
        setSelectedOptions([]);
        setFilteredData([]);        
      }         
    }  else {            
      if(e.target.checked) {
        setSelectedOptions(status);
        setFilteredData(nominationList);        
      } else {
        setSelectedOptions([]);
        setFilteredData([]);        
      }         
    }      
  }
  return <>        
    <FilterAltTwoToneIcon onClick={handleFilterShow} sx={{cursor: 'pointer','verticalAlign': 'bottom','font-size': '25px','margin-left': '6px'}}/>               
    {filterShow && <div className="primary_skill_filter">      
        <span className="arrow-up"></span>
        <div className="filter-section">
          <div className="search_container">        
            <input type="text" className="search_input" placeholder="&nbsp;&nbsp;Search..." value={searchTerm} onChange={handleSearch} onClick={(e) => e.stopPropagation()} />        
          </div>      
            <label className="select-all-option-label">              
              <input type="checkbox" checked={selectAll} onChange={(e) => handleCheckboxSelectAllChange(e)} />
              <span> Select All</span>               
            </label>                      
          {optionsData.map((option, index) => (
            <label key={index} className="option-label">              
              <input type="checkbox" checked={selectedOptions.includes(option)} onChange={(e) => handleCheckboxChange(e,option)} />
              &nbsp;{option}
            </label>
          ))}
        </div>
      </div>}
  </>
}